/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';

const getters = {
  [storeGetters.getTier]: (state) => {
    return state.tiers;
  },
  [storeGetters.getTiersCount]: (state) => {
    return state.tierCount;
  },
  // [storeGetters.getListOfCustomers]: (state) => {
  //   debugger;
  //   console.log("data is for",state.CustomersList)
  //   return state.CustomersList;
  // },

};
export default { ...getters };
